import React from "react";
import { Link, useLocation } from "react-router-dom";

export const GOLD = "#B08D57";

const MODULES = [
  ["/rh", "Ressources humaines"], ["/maintenance", "Parc & Maintenance"], ["/conformite", "Conformité & Contrôles"], ["/parametres", "Configuration"], ["/profils", "Configuration"],
  ["/admin", "Configuration"], ["/profil", "Mon profil"], ["/saisie", "Saisie du jour"], ["/mon-ca", "Mon chiffre d'affaires"],
];
export const useModuleName = () => {
  const { pathname } = useLocation();
  return (MODULES.find(([p]) => pathname === p || pathname.startsWith(`${p}/`)) || [null, "Trésorerie"])[1];
};

export function BrandMark({ className = "h-16" }) {
  return <img src="/logo-idagray-mark.png" alt="Logo IDA GRAY" className={`${className} w-auto shrink-0 object-contain`} />;
}

export function Brand({ home = "/", compact = false, size = "lg" }) {
  const module = useModuleName();
  const big = size === "lg";
  return (
    <Link to={home} aria-label="IDA GRAY — retour à l'accueil" data-testid="brand-home-link"
      className="group flex items-center gap-3 rounded-2xl outline-none focus-visible:ring-2 focus-visible:ring-[#065F46]/40">
      <BrandMark className={compact ? "h-11 max-w-[56px]" : big ? "h-[62px] max-w-[96px]" : "h-11 max-w-[70px]"} />
      {!compact && (
        <div className="min-w-0 leading-none">
          <p className={`font-display font-semibold tracking-[0.08em] text-[#0F2E25] ${big ? "text-[21px]" : "text-[17px]"}`} data-testid="brand-name">IDA GRAY</p>
          <p className={`mt-1 whitespace-nowrap font-semibold uppercase tracking-[0.16em] text-slate-500 ${big ? "text-[10.5px]" : "text-[9px]"}`}>Gestion du cabinet</p>
          <p className={`mt-2 flex items-center gap-1.5 font-semibold ${big ? "text-[13px]" : "text-[12px]"}`} style={{ color: GOLD }} data-testid="brand-module">
            <span className="h-px w-4" style={{ background: GOLD }} />{module}
          </p>
        </div>
      )}
    </Link>
  );
}
